import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class CreateSubscription {
    apiService

    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);

        this.apiService.enableAuth();
    }

    handle(payload) {
        let apiUrl = ApiEndpoints['subscriptions.store'];
        let parameters = {
            first_name: payload.firstName,
            last_name: payload.lastName,
            address1: payload.address1,
            address2: payload.address2 || null,
            city: payload.city,
            country: payload.country,
            postcode: payload.postcode,
            delivery_comment: payload.deliveryComment,
            property_type: payload.propertyType,
            what_three_words: payload.what_3_words || null,
            plan_slug: payload.plan_slug || null,
        };

        return this.apiService.post(apiUrl, parameters);
    }
}
